export enum IdentityProviderType {
    Local = 1,
    External = 2
}
